import PropTypes from 'prop-types'
import { routerPropTypes } from 'Types'
import React, { Component, Fragment } from 'react'
import { PAGE_CONTEXT as p } from 'Constants'
import { connect } from 'react-redux'
import get from 'lodash/get'
import View from './component'
import skins from './skins'
import { skin } from 'Utils'
import config from 'Config'
import {
  PageView,
  PageHelmet,
  JourneyTracker,
  TrackLinkDecrease,
  StoreLocation
} from 'Blocks'

const pageName = p.ARTICLE_LIST

class ArticleListPageContainer extends Component {
  render() {
    return (
      <Fragment>
        <PageView url={this.props.location.pathname} />
        <PageHelmet
          pageName={pageName}
          description={config.helmet.articles.description}
        />
        <TrackLinkDecrease url={this.props.location.pathname} />
        <StoreLocation location={this.props.location} />
        <JourneyTracker
          name="articles"
          routeName={pageName}
          location={this.props.location}
          params={this.props.match.params}
        />
        <View
          className={this.props.className}
          location={this.props.location}
          screenType={this.props.screenType}
          params={this.props.match.params}
        />
      </Fragment>
    )
  }
}

ArticleListPageContainer.propTypes = {
  className: PropTypes.string,
  screenType: PropTypes.string,
  ...routerPropTypes
}

const mapStateToProps = state => ({
  screenType: get(state, 'UI.screenType', '')
})

export default skin(
  connect(mapStateToProps, null)(ArticleListPageContainer),
  skins
)
